const locations = [
  "New York",
  "San Fran",
  "Austin",
  "Miami",
  "Boston",
  "Seattle ",
  "Salt Lake City",
  "Washington DC",
  "Los Angeles",
  "Dallas",

  "Tel Aviv, Israel",
  "Krakow, Poland",
  "Berlin, Germany",
  "Toronto, Canada",
  "Montreal",
  "Vancouver",
];

export default locations;
